import React from 'react';
import { Link } from 'react-router-dom';
import DeleteButton from '../../components/Global/DeleteButton';
import EnhanceButton from '../../components/Blog/EnhanceBlogPostButton';

function classNames(...classes) {
	return classes.filter(Boolean).join(' ');
}

export default function Table({ data, title, url, deleteRow }) {
	if (!data || data.length === 0) {
		return <div>No data available</div>;
	}

	const headers = Object.keys(data[0]);

	// Helper function to handle rendering different types of data
	const renderData = (data, header) => {
		if (header === 'img') {
			return (
				<img
					src={data}
					alt={data}
					className='w-10 h-10 rounded-md'
				/>
			);
		} else if (header === 'sections') {
			// recursive
			// return data.map((section, i) => {
			// 	return (
			// 		<div
			// 			className='overflow-scroll'
			// 			key={i}
			// 		>
			// 			{Object.keys(section).map((key) => {
			// 				return (
			// 					<div key={key}>
			// 						{key}: {section[key]}
			// 					</div>
			// 				);
			// 			})}
			// 		</div>
			// 	);
			// });
			return data.length;
		} else if (header === 'createdAt') {
			return new Date(data).toLocaleString();
		}
		// data types
		if (data === null || data === undefined) {
			return 'n/a';
		}
		if (Array.isArray(data)) {
			return data.join(', ');
		}
		if (typeof data === 'boolean') {
			return data ? 'True' : 'False';
		}
		if (typeof data === 'object') {
			//use recursion
			const keys = Object.keys(data);
			if (keys.length === 0) return 'n/a';
			return keys.map((key) => `${key}: ${data[key]}`).join(', ');
		}

		if (
			typeof data === 'string' &&
			header === '_id' &&
			title.toLowerCase().includes('blog')
		) {
			return (
				<Link
					className='hover:text-primary-500'
					to={`/blog/${data}`}
				>
					{data}
				</Link>
			);
		} else if (typeof data === 'string') {
			return data;
		}
	};

	return (
		<div>
			{url ? (
				<Link to={url}>
					<h2 className='px-4 text-base font-semibold leading-7 text-white sm:px-6 lg:px-8'>
						{title || ''}
					</h2>
				</Link>
			) : (
				<h2 className='px-4 text-base font-semibold leading-7 text-white sm:px-6 lg:px-8'>
					{title || ''}
				</h2>
			)}

			<table className='mt-6 w-full whitespace-nowrap text-left'>
				<thead className='border-b border-white/10 text-sm leading-6 text-white'>
					<tr>
						{title.toLowerCase().includes('blog') && deleteRow && (
							<>
								<th
									scope='col'
									className='py-2 pl-4 pr-8 font-semibold sm:pl-6 lg:pl-8'
								>
									delete
								</th>
								<th
									scope='col'
									className='py-2 pl-4 pr-8 font-semibold sm:pl-6 lg:pl-8'
								>
									enhance
								</th>
							</>
						)}
						{headers.map((header, index) => (
							<th
								scope='col'
								key={index}
								className='py-2 pl-4 pr-8 font-semibold sm:pl-6 lg:pl-8'
							>
								{header}
							</th>
						))}
					</tr>
				</thead>
				<tbody className='divide-y divide-white/5'>
					{data.map((item, rowIndex) => (
						<tr key={rowIndex}>
							{title.toLowerCase().includes('blog') && deleteRow && (
								<>
									<td className='py-4 pl-4 pr-8 sm:pl-6 lg:pl-8'>
										{title.toLowerCase().includes('blog') && deleteRow && (
											<DeleteButton
												modelId={item._id}
												className='text-white bg-rose-500 font-bold hover:bg-rose-700 px-3 py-1.5 rounded'
												deleteFunction={deleteRow}
											/>
										)}
									</td>
									<td className='py-4 pl-4 pr-8 sm:pl-6 lg:pl-8'>
										{title.toLowerCase().includes('blog') && (
											<EnhanceButton blogId={item._id} />
										)}
									</td>
								</>
							)}

							{headers.map((header, cellIndex) => (
								<td
									key={cellIndex}
									className='py-4 pl-4 pr-8 sm:pl-6 lg:pl-8'
								>
									<div className='truncate max-w-sm text-sm font-medium leading-6 text-white'>
										{renderData(item[header], header)}
									</div>
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
